import * as React from 'react';
import { useTheme } from '../../theme';
var SimpleLoader = function () {
    var css = useTheme('SimpleLoader').SimpleLoaderStyles;
    return (React.createElement("div", { className: css.wrapper },
        React.createElement("div", { className: css.loader })));
};
export default SimpleLoader;
